module.exports = __webpack_public_path__ + "static/media/nervosity-mismatch-1-fr.8312de31.png";